module.exports = __webpack_public_path__ + "static/media/education.3bab7a9d.svg";